/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Export_Report_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Export Report" |
*
* @param {Style_Guide_Export_Report_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_export_report_aria_label = /** @type {((inputs?: Style_Guide_Export_Report_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Export_Report_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter le rapport")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportbericht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rapporto di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отчет об экспорте")
	if (locale === "es") return /** @type {LocalizedString} */ ("Informe de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口报告")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートレポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात रिपोर्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Relatório de Exportação")
	return /** @type {LocalizedString} */ ("Export Report")
});